(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pethouse-collection-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('brand-carousel')) {
    customElements.define(
      'brand-carousel',
      class BrandCarousel extends HTMLElement {
        connectedCallback() {
          if (this.dataset.initialized === 'true') return;
          this.dataset.initialized = 'true';

          this.track = this.querySelector('[data-brand-track]');
          this.previousButton = this.querySelector('[data-brand-prev]');
          this.nextButton = this.querySelector('[data-brand-next]');
          if (!this.track || !this.previousButton || !this.nextButton) return;

          this.previousButton.addEventListener('click', () => this.move(-1));
          this.nextButton.addEventListener('click', () => this.move(1));
          this.track.addEventListener('scroll', () => this.updateButtons(), { passive: true });
          window.addEventListener('resize', () => this.updateButtons());
          this.updateButtons();
        }

        move(direction) {
          const card = this.track.querySelector('.pethouse-collection-card');
          if (!card) return;
          const styles = getComputedStyle(this.track);
          const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
          this.track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
        }

        updateButtons() {
          const maximum = this.track.scrollWidth - this.track.clientWidth;
          this.previousButton.disabled = this.track.scrollLeft <= 2;
          this.nextButton.disabled = this.track.scrollLeft >= maximum - 2;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pethouse-promotion-carousel"] && !Shopify.designMode) return;
  try {
    
  const initializePromotionCarousel = (carousel) => {
    if (carousel.dataset.initialized === 'true') return;

    const track = carousel.querySelector('.pethouse-promotions__track');
    const slides = [...carousel.querySelectorAll('[data-carousel-slide]')];
    const dots = [...carousel.querySelectorAll('[data-carousel-dot]')];
    const status = carousel.querySelector('[data-carousel-status]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let index = 0;
    let timer = null;

    if (!track || slides.length < 2) return;
    carousel.dataset.initialized = 'true';

    const updateControls = () => {
      dots.forEach((dot, dotIndex) => dot.setAttribute('aria-current', dotIndex === index ? 'true' : 'false'));
      if (status) status.textContent = `Showing promotion ${index + 1} of ${slides.length}`;
    };

    const stop = () => {
      window.clearInterval(timer);
      timer = null;
    };

    const goTo = (nextIndex) => {
      index = (nextIndex + slides.length) % slides.length;
      track.scrollTo({ left: index * track.clientWidth, behavior: reducedMotion ? 'auto' : 'smooth' });
      updateControls();
    };

    const start = () => {
      if (carousel.dataset.autoplay !== 'true' || reducedMotion || timer) return;
      timer = window.setInterval(() => goTo(index + 1), Number(carousel.dataset.speed) || 5000);
    };

    carousel.querySelector('[data-carousel-previous]')?.addEventListener('click', () => goTo(index - 1));
    carousel.querySelector('[data-carousel-next]')?.addEventListener('click', () => goTo(index + 1));
    dots.forEach((dot, dotIndex) => dot.addEventListener('click', () => goTo(dotIndex)));
    track.addEventListener(
      'scrollend',
      () => {
        index = Math.round(track.scrollLeft / track.clientWidth);
        updateControls();
      },
      { passive: true }
    );
    carousel.addEventListener('mouseenter', stop);
    carousel.addEventListener('mouseleave', start);
    carousel.addEventListener('focusin', stop);
    carousel.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', () => (document.hidden ? stop() : start()));
    start();
  };

  const initializePromotionCarousels = (container = document) => {
    container.querySelectorAll('[data-promotion-carousel]').forEach(initializePromotionCarousel);
  };

  initializePromotionCarousels();
  document.addEventListener('shopify:section:load', (event) => initializePromotionCarousels(event.target));

  } catch(e) { console.error(e); }
})();
})();
